module.exports = __webpack_public_path__ + "static/media/red-dot-anima.8c8a4d1d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/red-dot-anima.gif
// module id = 186
// module chunks = 0